export const BASEURL = process.env.VUE_APP_BASEURL;
export const FILESURL = process.env.VUE_APP_FILESURL;
export const RAZORPAY_KEY_ID = process.env.VUE_APP_RAZORPAY_KEY_ID;

export const API_VERSION = "v1.0";